/* eslint-disable import/no-unused-modules */
import React from 'react';
import PropTypes from 'prop-types';
import AssetNrByLimitsComponent from './AssetNrByLimitsComponent';
// eslint-disable-next-line react/display-name
const AssetLimitsSummaryComponent = React.memo(({ item, isLabelVisible, leftPanelSize }) => {
    const isLeftpanelSizeSmall = leftPanelSize <= 50;
    return (
        <div className={`condition-index limits ${isLeftpanelSizeSmall ? 'left-sidebar-cell' : 'powertrain__cell'}`}>
            <div className='kpis'>
                <AssetNrByLimitsComponent
                    asset={item?.limits}
                    conditionType={'Limits'}
                    isLabelVisible={isLabelVisible}
                    leftPanelSize={leftPanelSize}
                ></AssetNrByLimitsComponent>
            </div>
        </div>
    );
});

AssetLimitsSummaryComponent.propTypes = {
    item: PropTypes.object,
    isLabelVisible: PropTypes.bool,
    leftPanelSize: PropTypes.number
};

export default AssetLimitsSummaryComponent;
